// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class UserSettingsRequests {
    /**
     * @param {number} userId
     * @returns {Promise<ImportSettingsDefaults>}
     */
    async GetImportSettingsDefaults(userId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/GetImportSettingsDefaults',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     * @returns {Promise<GetSettingsResponse>}
     */
    async GetSettings(userId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/GetSettings',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     * @returns {Promise<GetUserInfoResponse>}
     */
    async GetUserInfo(userId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/GetUserInfo',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }

    /**
    * @param {number} userId
    * @param {string} contactLid
    * @returns {Promise<ValueResponse<UserState>>}
    */
    async DeleteDL(userId, contactLid) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/DeleteDL',
            method: 'POST',
            body: { userId: userId, contactLid: contactLid },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {{[k: string]: any}} settings
     * @param {number} userId
     * @param {string | null} edsArchive
     * @param {boolean} doSyncUser
     * @param {string} receiveDocumentsFrom
     * @param {string[]} cabinetDLsContactLidsToSave
     * @returns {Promise<ValueResponse<SaveSettingsResult>>}
     */
    async SaveSettings(settings, userId, edsArchive, doSyncUser, receiveDocumentsFrom, cabinetDLsContactLidsToSave) {
        /** @type {SaveSettingsRequest} */
        let request = {
            settings: settings,
            userId: userId,
            edsArchive: edsArchive,
            doSyncUser: doSyncUser,
            receiveDocumentsFromString: receiveDocumentsFrom,
            cabinetDLs: cabinetDLsContactLidsToSave
        };

        return await SmrClient.FetchJson({
            url: 'UserSettings/SaveSettings',
            method: 'POST',
            body: request
        });
    };

    /**
     * @param {string} userLid
     */
    async GetAnomalies(userLid) {
        await SmrClient.FetchDownload({
            url: 'UserSettings/GetAnomalies',
            method: 'POST',
            body: { userLid: userLid },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     * @param {number} donorId
     * @returns {Promise<ValueResponse<CopySettingsResult>>}
     */
    async CopySettings(userId, donorId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/CopySettings',
            method: 'POST',
            body: { userId: userId, donorId: donorId },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {string} userLid
     */
    async CleanUsersModal(userLid) {
        await SmrClient.FetchJson({
            url: 'UserSettings/CleanUsersModal',
            method: 'POST',
            body: { userLid: userLid },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     * @returns {Promise<ValueResponse<UserState>>}
     */
    async UpdateDictionary(userId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/UpdateDictionary',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }

    /**
     * @returns {Promise<ValueResponse<TreeItem<Rubric, string>[]>>}
     */
    async GetRubrics() {
        return await SmrClient.FetchJson({
            url: 'UserSettings/GetRubrics',
            method: 'GET'
        });
    }

    /**
     * @param {string} text
     * @returns {Promise<ValueResponse<PersonSearchResult[]>>}
     */
    async SearchAssistent(text) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/SearchAssistent',
            method: 'POST',
            body: { text: text },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     * @returns {Promise<GetCabinetDLsResult>}
     */
    async GetCabinetDLs(userId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/GetCabinetDLs',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     */
    async ExportUserSettings(userId) {
        await SmrClient.FetchDownload({
            url: 'UserSettings/ExportUserSettings',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} userId
     * @returns {Promise<ValueResponse<UserState>>}
     */
    async StopSync(userId) {
        return await SmrClient.FetchJson({
            url: 'UserSettings/StopSync',
            method: 'POST',
            body: { userId: userId },
            bodyIsUrlParams: true
        });
    }
}

export default new UserSettingsRequests;